import { GET_STATES } from '../mutation-types'
import helperApi from '../../api/HelperApi'

const state = {
  statesList: []
}

const getters = {
  statesById: (state) => {
    const result = {}
    state.statesList.forEach(state => {
      result[state.id] = state
    })
    return result
  }
}

const actions = {
  async getStates ({ state, commit }) {
    if (state.statesList.length) {
      return Promise.resolve(state.statesList)
    }
    try {
      const states = await helperApi.getStates()
      commit(GET_STATES, states)
      return states
    } catch (e) {
      return e
    }
  }
}

const mutations = {
  [GET_STATES] (state, stateList) {
    state.statesList = stateList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
